<template>
    <AuthenticatedLayout>

        <Toast position="top-center" />

        <Dialog :visible.sync="displayDealsModal" :containerStyle="{width: '50vw'}">
            <template #content>
<!--                <div class="mb-4">Было сделок:</div>-->
                <div class="mb-4">Было сделок: {{deals.length}}</div>
                <DataTable :value="deals" dataKey="buy_at">
                    <Column field="type" header="type" ></Column>
                    <Column field="buy_at" header="buy_at" ></Column>
                    <Column field="sell_at" header="sell_at" ></Column>
                    <Column field="value_profit" header="value_profit" ></Column>
                </DataTable>
            </template>
            <template #footer>
                <Button label="Close" autofocus @click="displayDealsModal = false" />
            </template>
        </Dialog>

        <div class="text-4xl mr-4 my-4 ">Lorentz bot emulator analyze</div>

        <p class="my-4">Эксперимент по работе с сигналами Lorentzian Classification</p>
        <Card>
            <template #content>
                <DataTable :value="dataByPairs" dataKey="pair_name" :expandedRows.sync="expandedRows">
                    <Column :expander="true" :headerStyle="{'width': '3rem'}" />
                    <Column field="pair_id" header="id" :headerStyle="{'width': '1rem'}"></Column>
                    <Column class="w-10rem">
                        <template #body="slotProps">
                            <div class="flex flex-row align-items-center">
                                <div class="flex align-items-center justify-content-center full-rounded" style="width:2.5rem;height:2.5rem">
                                    <img :src="slotProps.data.pair_icon_url" style="width:2.5rem;height:2.5rem" class="full-rounded" :alt="slotProps.data.pair_name"/>
                                </div>
                                <div class="text-xl ml-4">
                                    {{slotProps.data.pair_name}}
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column header="openLong - endLong" class="w-6rem">
                        <template #body="slotProps">
                            <div class="flex flex-row align-items-center">
                                <div class="">
                                    {{slotProps.data.openLong_endLong.value_profit}}
                                </div>
                                <div class="text-gray-500 ml-2">
                                    ({{slotProps.data.openLong_endLong.maxUsedMoney}}, {{slotProps.data.openLong_endLong.percent_profit}})
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column field="openShort_endShort.value_profit" header="openShort - endShort" class="w-6rem">
                        <template #body="slotProps">
                            <div class="flex flex-row align-items-center">
                                <div class="">
                                    {{slotProps.data.openShort_endShort.value_profit}}
                                </div>
                                <div class="text-gray-500 ml-2">
                                    ({{slotProps.data.openShort_endShort.maxUsedMoney}}, {{slotProps.data.openShort_endShort.percent_profit}})
                                </div>
                            </div>
                        </template>
                    </Column>
                    <ColumnGroup type="footer">
                        <Row>
                            <Column footer="Профит (сделка - 100$):" :colspan="3" />
                            <Column :footer="value_oLong_eLong" />
                            <Column :footer="value_oShort_eShort" />
                        </Row>
                    </ColumnGroup>
                    <template #expansion="slotProps">
                        <div class="flex flex-row">
                            <div class="mr-4">
                                <div class="mb-2">openLong_endLong</div>
                                <DataTable :value="slotProps.data.openLong_endLong.deals" dataKey="buy_at">
                                    <Column field="type" header="type" ></Column>
                                    <Column field="buy_at" header="buy_at" ></Column>
                                    <Column field="buy_price" header="buy_price" ></Column>
                                    <Column field="sell_at" header="sell_at" ></Column>
                                    <Column field="sell_price" header="sell_price" ></Column>
                                    <Column field="value_profit" header="value_profit" ></Column>
                                </DataTable>
                            </div>
                            <div class="mr-4">
                                <div class="mb-2">openShort_endShort</div>
                                <DataTable :value="slotProps.data.openShort_endShort.deals" dataKey="buy_at">
                                    <Column field="type" header="type" ></Column>
                                    <Column field="buy_at" header="buy_at" ></Column>
                                    <Column field="buy_price" header="buy_price" ></Column>
                                    <Column field="sell_at" header="sell_at" ></Column>
                                    <Column field="sell_price" header="sell_price" ></Column>
                                    <Column field="value_profit" header="value_profit" ></Column>
                                </DataTable>
                            </div>
                        </div>

                    </template>
                </DataTable>
            </template>
        </Card>




    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import helperMethods from '@/helpers';
import Card from "primevue/card";
import InputSwitch from "primevue/inputswitch";
import PairsTwoTableSelector from "@/Menu/PairsTwoTableSelector.vue";
import Button from "primevue/button";
import Dialog from 'primevue/dialog';

export default {
    components:{
        PairsTwoTableSelector,
        AuthenticatedLayout, Toast, DataTable, Column, ColumnGroup, Row, Card, InputSwitch, Button, Dialog
    },
    props:{
        dataByPairs: Array,
        average_oLong_eLong: Number,
        average_oLong_oShort: Number,
        value_oLong_eLong: Number,
        value_oLong_oShort: Number,
        value_oShort_eShort: Number,
        value_oShort_oLong: Number,
    },
    data(){
        return {
            selectedPair: null,
            displayDealsModal: false,
            deals: [],
            expandedRows: null,
        }
    },
    methods:{
        ...helperMethods,
        showDealsModal(deals){
            this.deals = deals;
            this.displayDealsModal = true;
            //console.log(this.displayDealsModal);
        }
    }


}
</script>
